import { render } from "./MaterialSupportView.vue?vue&type=template&id=d8cec13e&scoped=true"
import script from "./MaterialSupportView.vue?vue&type=script&lang=js"
export * from "./MaterialSupportView.vue?vue&type=script&lang=js"

import "./MaterialSupportView.vue?vue&type=style&index=0&id=d8cec13e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8cec13e"]])

export default __exports__